import menuItem from './menuItem';
export default {
  name: 'subMenu',
  components: {
    menuItem
  },
  props: {
    currentRoute: {
      type: Object,
      required: true
    }
  }
};